import type { DeepPartial } from '@luna/utils-ts';

import type { Trading } from '../../types';

export const tradingConfigAT: DeepPartial<Trading> = {
    allowRegularBuyOrders: true,
    applyOnlyOtcOrSofaForValidUntil: true,
    applyValidFromForSell: true,
    includeIsinInQuestionnaireUrl: true,
    marketTradingConditionsUrl: 'https://www.sparkasse.at/tiny/boersenusancen',
    redirectRegularBuyToStore: true,
    shouldLoadTradingDocuments: true,
    showRiskDisclosureWarning: true,
    showTargetPortfolio: true,
    tradingValidationStrategies: {
        accountTradeableStatus: true,
        accountTradingActivationAllowed: true,
        profileSecuritiesTradingAllowedFlag: true,
    },
    version: 1,
};
